import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Form, Input, App } from 'antd'
import { passwordRegex } from '@/utils/regex'
import PrimeModal from '@/components/primeModal/index'
import { editPwd } from '@/api/user'
import useStore from '@/store/persistStore'
import { useTranslation } from 'react-i18next'
import { cryptoPassword } from '@/utils'

const ChangePwd = (props: any, ref: any) => {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const { getState } = useStore
  const { loginInfo } = getState() as any

  const open = () => {
    setVisible(true)
  }

  const close = () => {
    form.resetFields()
    setVisible(false)
  }

  useImperativeHandle(ref, () => ({
    open,
  }))

  const handleSubmit = async (values: any) => {
    delete values.confirmPwd
    try {
      await editPwd({
        ...values,
        id: loginInfo.id,
        oldPwd: cryptoPassword(values.oldPwd),
        newPwd: cryptoPassword(values.newPwd)
      })
      close()
      message.success(t('ikg.success', { action: t('ikg.changePwd') }))
      typeof props.onSuccess === 'function' && props.onSuccess()
    } catch (error) {
      close()
    }
  }

  return (
    <PrimeModal
      title={t('ikg.changePwd')}
      open={visible}
      onCancel={close}
      onOk={() => form.submit()}
      width={640}
      {...props.modalProps}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label={t('user.oldPwd')}
          name="oldPwd"
          rules={[{ required: true, message: t('user.pwdRequired') }]}
        >
          <Input.Password
            placeholder={t('ikg.input', { name: t('user.oldPwd') })}
            type="password"
          />
        </Form.Item>
        <Form.Item
          label={t('user.newPwd')}
          name="newPwd"
          rules={[
            { required: true, message: t('user.pwdRequired') },
            {
              pattern: passwordRegex,
              message: t('user.pwdRegex'),
            },
          ]}
        >
          <Input.Password
            placeholder={t('ikg.input', { name: t('user.newPwd') })}
            type="password"
          />
        </Form.Item>
        <Form.Item
          label={t('user.confirmPwd')}
          name="confirmPwd"
          rules={[
            { required: true, message: t('user.pwdRequired') },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('newPwd') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(t('user.pwdNotSame'))
              },
            }),
          ]}
        >
          <Input.Password
            placeholder={t('ikg.input', { name: t('user.confirmPwd') })}
            type="password"
          />
        </Form.Item>
      </Form>
    </PrimeModal>
  )
}

export default forwardRef(ChangePwd)
